export default __webpack_public_path__ + "static/media/special_cubes_gallery_02.a40a707b.png";